import React from 'react'
import cx from 'classnames'
import * as R from 'ramda'

import { Box } from 'components/layout/Box/Box'
// import { IconButton } from 'components/shared/IconButton/IconButton'
import { StepProgressGroup } from 'components/shared/StepProgressGroup/StepProgressGroup'

import { getEvaluations } from '../../model'

// import { CopyIcon, Edit3Icon, Trash2Icon } from 'components/shared/Icon/Icon'

import styles from './EvaluatorCard.module.scss'

export const EvaluatorCard = ({
  className = undefined,
  email,
  // id,
  name,
  // shareable_url,
  status,
  // onCopyLink,
  // onEditEvaluator,
  // onRemoveEvaluator,
  // isRemoveDisabled,
}) => {
  const evaluations = getEvaluations(status)

  return (
    <Box
      ariaRole="presentation"
      className={styles.card}
      direction="column"
      tagName="article"
    >
      <Box className={styles.header} justify="space-between" tagName="header">
        <address
          className={cx(styles.evaluator, { [className]: Boolean(className) })}
        >
          <p className={styles.name}>{name}</p>
          <p className={styles.email}>{email}</p>
        </address>
      </Box>
      <Box className={styles.progress} direction="column" tagName="footer">
        <StepProgressGroup size="small" steps={R.values(evaluations)} />
        <p className={styles.status}>
          {R.values(evaluations)[status - 1].name}
        </p>
      </Box>
      {/* <Box
        align="center"
        className={styles.actions}
        justify="center"
        tagName="footer"
      >
        <IconButton
          ariaLabel="copy"
          className={styles.button}
          icon={CopyIcon}
          size="xsmall"
          variant="outlined"
          onClick={() => onCopyLink(shareable_url)}
        />
        <IconButton
          ariaLabel="edit"
          className={styles.button}
          icon={Edit3Icon}
          size="xsmall"
          variant="outlined"
          onClick={() => onEditEvaluator({ uuid: id })}
        />
        <IconButton
          ariaLabel="delete"
          className={styles.button}
          icon={Trash2Icon}
          size="xsmall"
          variant="outlined"
          onClick={() => onRemoveEvaluator({ uuid: id })}
          isDisabled={isRemoveDisabled}
        />
      </Box> */}
    </Box>
  )
}
